import { apiCall } from "./auth";
import { API_URL } from "./config";

export const addIron = (data, event) => apiCall(`${API_URL}Fitting/addFitting`, "POST", data, event);

export const getfittingFollow = (data, event) => apiCall(`${API_URL}Fitting/getfittingFollow`, "POST", data, event);

export const updateIron = (data) => apiCall(`${API_URL}Fitting/updateIronFitting`, "POST", data);
export const updateFitting = (data, event) => apiCall(`${API_URL}Fitting/updateFitting`, "POST", data, event);


export const getFittingById = (data, event) => apiCall(`${API_URL}Fitting/getFittingById`, "POST", data, event);

export const getIronFittingByUserId = (data) => apiCall(`${API_URL}Fitting/getIronFittingByUserId`, "POST", data);

export const getIronNotes = (data) => apiCall(`${API_URL}Fitting/getIronNotes`, "POST", data);

export const updateFittingStage = (data, event) => apiCall(`${API_URL}remotefittinginquires/updateRemoteInquiry`, "POST", data, event);

export const filterByFollowupStage = (data, event) => {
    let keyword = data.params.selectedKeyword;
    return apiCall(`${API_URL}Fitting/filterByFollowupStage/?keyword=${keyword}`, "GET", data, event);
}

export const filterByFitting = (data, event) => {
    return apiCall(`${API_URL}Fitting/searchFittingData`, "POST", data, event);
}

export const getclubFollow = (data) => apiCall(`${API_URL}cluborder/getclubFollow`, "POST", data);

export const getclubFollowbyid = (data) => apiCall(`${API_URL}cluborder/getclubFollowbyid`, "POST", data);

export const updatecluborder = (data) => apiCall(`${API_URL}cluborder/updatecluborder`, "POST", data);

export const getremoteInquiryapi = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittinginquires`, "POST", data);


export const getremoteInquirydataApi = (data) => apiCall(`${API_URL}remotefittinginquires/getallremotefittinginquiresbyid`, "POST", data);

export const updateRemoteInquiry = (data) => apiCall(`${API_URL}remotefittinginquires/updateRemoteInquiry`, "POST", data);

export const getclubfollowactivityapi = (data) => apiCall(`${API_URL}cluborder/getclubfollowactivity`, "POST", data);

export const getUserById = (data) => apiCall(`${API_URL}Fitting/getUserById`, "POST", data);

export const getfittingfollowdata = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittinginquires`, "POST", data);

export const removeuserdatails = (data) => apiCall(`${API_URL}remotefittinginquires/removeuserdatails`, "POST", data);

export const authorizeRemoteInquiry = (data) => apiCall(`${API_URL}remotefittinginquires/authorizeRemoteInquiry`, "POST", data);

export const getremotefittingdatabyuser = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittingdatabyuser`, "POST", data);

export const getremotefittingdatabyuser2 = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittingdatabyuser2`, "POST", data);

export const getremotefittingdatabyfitter = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittingdatabyfitter`, "POST", data);

export const addremotefittingapi = (data) => apiCall(`${API_URL}remotefittinginquires/addremotefittingapi`, "POST", data);

export const updateRemoteInquiryandupdateuser = (data) => apiCall(`${API_URL}remotefittinginquires/updateRemoteInquiryandupdateuser`, "POST", data);

export const getallremotefittinginquires = (data) => apiCall(`${API_URL}remotefittinginquires/getallremotefittinginquires`, "POST", data);

export const allremotefittinginquires = (data) => apiCall(`${API_URL}remotefittinginquires/allremotefittinginquires`, "POST", data);

export const getsingleprescription = (data) => apiCall(`${API_URL}prescription/getsingleprescription`, "POST", data);

export const getsinglebuildsheetData = (data) => apiCall(`${API_URL}buildsheet/getsinglebuildsheetData`, "POST", data);

// getsinglestagestation ,getsinglebuilstation ,getsingleshipstagestation
export const getsinglestagestation = (data) => apiCall(`${API_URL}stagingStations/getsinglestagestation`, "POST", data);

export const getsinglebuilstation = (data) => apiCall(`${API_URL}buildstations/getsinglebuilstation`, "POST", data);

export const getsingleshipstagestation = (data) => apiCall(`${API_URL}shipstations/getsingleshipstagestation`, "POST", data);

export const getsinglepickupstation = (data) => apiCall(`${API_URL}shipstations/getpickupstationbyid`, "POST", data);

export const getallclubremotefittinginquires = (data) => apiCall(`${API_URL}remotefittinginquires/getallclubremotefittinginquires`, "POST", data);

export const getallremotefittinginquiresbyfitter = (data) => apiCall(`${API_URL}remotefittinginquires/getallremotefittinginquiresbyfitter`, "POST", data);

export const getallprojectbyfitter = (data) => apiCall(`${API_URL}remotefittinginquires/getallprojectbyfitter`, "POST", data);

export const getremotefittingforuser = (data) => apiCall(`${API_URL}remotefittinginquires/getremotefittinguser`, "POST", data);

export const addbuildsheetdirect = (data) => apiCall(`${API_URL}remotefittinginquires/addbuildsheetdirect`, "POST", data);

export const getemptyremotekitapi = (data) => apiCall(`${API_URL}remotefittinginquires/getassignremotekitapi`, "POST", data);

export const assignremoteKitapi = (data) => apiCall(`${API_URL}remotefittinginquires/assignremoteKitapi`, "POST", data);

export const getremotekits = (data) => apiCall(`${API_URL}remotefittinginquires/getremotekits`, "POST", data);

export const updateRemotekit = (data) => apiCall(`${API_URL}remotefittinginquires/updateRemotekit`, "POST", data);

export const addnewgolferapi = (data) => apiCall(`${API_URL}remotefittinginquires/addnewgolferapi`, "POST", data);

export const updatenewgolfer = (data) => apiCall(`${API_URL}remotefittinginquires/updatenewgolfer`, "POST", data);

export const updatedata = (data) => apiCall(`${API_URL}remotefittinginquires/updatedata`, "POST", data);

export const updatedataremotefittingobjects = (data) => apiCall(`${API_URL}remotefittinginquires/updatedataremotefittingobjects`, "POST", data);

export const updatedataprescriptionobjects = (data) => apiCall(`${API_URL}prescription/updatedataprescriptionobjects`, "POST", data);

export const updatedataremotestar = (data) => apiCall(`${API_URL}remotefittinginquires/updatedataremotestar`, "POST", data);

export const getunsubmitfittingdata = (data) => apiCall(`${API_URL}remotefittinginquires/getunsubmitfittingdata`, "POST", data);

export const createRemotefittingdata = (data) => apiCall(`${API_URL}remotefittinginquires/createRemotefittingdata`, "POST", data);

export const addprojectdirect = (data) => apiCall(`${API_URL}remotefittinginquires/addprojectdirect`, "POST", data);

export const addstduionprojectdirect = (data) => apiCall(`${API_URL}remotefittinginquires/addstduionprojectdirect`, "POST", data);

export const deleteinquiry = (data) => apiCall(`${API_URL}remotefittinginquires/deleteinquiry`, "POST", data);

export const sendvarification = (data) => apiCall(`${API_URL}remotefittinginquires/sendvarification`, "POST", data);

export const sendvarificationbuilder = (data) => apiCall(`${API_URL}remotefittinginquires/sendvarificationbuilder`, "POST", data);

export const removeproject = (data) => apiCall(`${API_URL}remotefittinginquires/removeproject`, "POST", data);

export const sendemailvarification = (data) => apiCall(`${API_URL}remotefittinginquires/sendemailvarification`, "POST", data);

export const getfitterbuilder = (data) => apiCall(`${API_URL}Staff/getfitterbuilder`, "POST", data);

export const createorder = (data) => apiCall(`${API_URL}orders/createorder`, "POST", data);

export const getOrderdataapi = (data) => apiCall(`${API_URL}orders/getOrderdata`, "POST", data);

export const getorderbyfitter = (data) => apiCall(`${API_URL}orders/getorderbyfitter`, "POST", data);

export const getorderbydata = (data) => apiCall(`${API_URL}orders/getorderdetails`, "POST", data);

export const updateorderdata = (data) => apiCall(`${API_URL}orders/updateorderdata`, "POST", data);

export const deleteorder = (data) => apiCall(`${API_URL}orders/deleteorder`, "POST", data);

export const updateorderstatus = (data) => apiCall(`${API_URL}orders/updateorderstatus`, "POST", data);

export const updatestaffstage = (data) => apiCall(`${API_URL}Staff/updatestaffstage`, "POST", data);

export const getunaprrovedfitterdata = (data) => apiCall(`${API_URL}Staff/getunaprrovedfitterdata`, "POST", data);

export const getfitterbyid = (data) => apiCall(`${API_URL}Staff/getfitterbyid`, "POST", data);

export const updatestaffrole = (data) => apiCall(`${API_URL}Staff/updatestaffrole`, "POST", data);

export const updatestafflocation = (data) => apiCall(`${API_URL}Staff/updatestafflocation`, "POST", data);

export const staffassignkit = (data) => apiCall(`${API_URL}Staff/staffassignkit`, "POST", data);

export const updateStaff = (data) => apiCall(`${API_URL}Staff/updateStaff`, "POST", data);

export const assignqueue = (data) => apiCall(`${API_URL}remotefittinginquires/assignqueue`, "POST", data);


export const updatedeliverytypebyadmin = (data) => apiCall(`${API_URL}remotefittinginquires/updatedeliverytypebyadmin`, "POST", data);

export const resetremotefitting = (data) => apiCall(`${API_URL}remotefittinginquires/resetremotefitting`, "POST", data);

export const getpartykits = () => apiCall(`${API_URL}remotefittinginquires/getpartykits`, "GET",);

export const removebuilderfitter = (data) => apiCall(`${API_URL}Staff/removebuilderfitter`, "POST", data);

export const getactivefitters = (data) => apiCall(`${API_URL}Staff/getactivefitters`, "POST", data);

export const getcountries = () => apiCall(`${API_URL}user/getcountries`, "GET");
export const getcountriesforfitter = () => apiCall(`${API_URL}user/getcountriesforfitter`, "GET");
export const getstates = (data) => apiCall(`${API_URL}user/getstates`, "POST", data);
export const getcities = (data) => apiCall(`${API_URL}user/getcities`, "POST", data);

export const updatestaffstagepartykitstatus = (data) => apiCall(`${API_URL}Staff/updatestaffstagepartykitstatus`, "POST", data);

export const getstateslocator = (data) => apiCall(`${API_URL}user/getstateslocator`, "POST", data);
export const getcitieslocator = (data) => apiCall(`${API_URL}user/getcitieslocator`, "POST", data);

export const searchfitters = (data) => apiCall(`${API_URL}Staff/searchfitters`, "POST", data);
export const filterpost = (data) => apiCall(`${API_URL}Staff/filter-post`, "POST", data);

export const getassignkit = () => apiCall(`${API_URL}Staff/getassignkit`, "GET");

export const getassignunPartys = () => apiCall(`${API_URL}Staff/getassignunPartys`, "GET");

export const updatepartykit = (data) => apiCall(`${API_URL}Staff/updatepartykit`, "POST", data);

export const createposts = (data) => apiCall(`${API_URL}posts/createposts`, "POST", data);
export const getpostsbyfitter = (data) => apiCall(`${API_URL}posts/getpostsbyfitter`, "POST", data);
export const updatepost = (data) => apiCall(`${API_URL}posts/updatepost`, "POST", data);

export const removepost = (data) => apiCall(`${API_URL}posts/deletepost`, "POST", data);

export const addreferral = (data) => apiCall(`${API_URL}user/addreferral`, "POST", data);

export const getreferral = () => apiCall(`${API_URL}user/getreferral`, "GET");

export const getreferralforfront = () => apiCall(`${API_URL}user/getreferralforfront`, "GET");

export const assignreferral = (data) => apiCall(`${API_URL}remotefittinginquires/assignreferral`, "POST", data);

export const getprojectbyreferral = (data) => apiCall(`${API_URL}remotefittinginquires/getprojectbyreferral`, "POST", data);